export default __webpack_public_path__ + "static/media/note-taker-screenshot.c465157f.png";